import { makeStyles } from '@material-ui/core/styles'
import { colors } from 'src/components/app-ui'

const useStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  setup: {
    maxWidth: 1080,
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },

  // Status hero
  hero: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '20px',
    padding: '20px 24px',
    borderRadius: '16px',
  },
  heroIcon: {
    width: 44,
    height: 44,
    flex: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '12px',
    background: '#FFFFFF',
    boxShadow: '0 1px 2px rgba(145,158,171,.3)',
  },
  heroText: {
    flex: 1,
    minWidth: 220,
  },
  heroTitle: {
    fontSize: '17px',
    fontWeight: 600,
    color: colors.navy,
  },
  heroSub: {
    marginTop: 3,
    fontSize: '13px',
    color: colors.muted,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 12px 6px 10px',
    border: `1px solid ${colors.border}`,
    borderRadius: '999px',
    background: '#FFFFFF',
    fontSize: '13px',
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
  },
  chipName: {
    fontWeight: 500,
    color: colors.navy,
  },
  chipStatus: {
    color: colors.subtle,
  },
  chipRemove: {
    display: 'inline-flex',
    padding: '0 0 0 2px',
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    color: colors.subtle,
    '&:hover': {
      color: colors.error,
    },
  },

  // Tool picker
  picker: {
    alignSelf: 'flex-start',
    display: 'inline-flex',
    gap: '4px',
    padding: '4px',
    borderRadius: '10px',
    background: colors.hover,
  },
  pickerItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 16px',
    border: 0,
    borderRadius: '8px',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '14px',
  },
  pickerDot: {
    width: 7,
    height: 7,
    borderRadius: '50%',
    background: colors.success,
  },

  // Video card
  // ChatGPT: the official app's button, badge and the path to it.
  app: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  appRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
  },
  addButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    background: colors.primary,
    color: '#FFFFFF',
    borderRadius: '8px',
    padding: '11px 20px',
    fontSize: '14px',
    fontWeight: 600,
    textDecoration: 'none',
    '&:hover': { background: '#0151D5' },
  },
  official: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    background: '#E9F1FF',
    color: '#0151D5',
    borderRadius: '999px',
    padding: '4px 12px',
    fontSize: '12px',
    fontWeight: 500,
  },
  crumbs: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    flexWrap: 'wrap',
    fontSize: '13px',
    color: colors.muted,
  },
  crumb: {
    background: '#F4F6F8',
    borderRadius: '6px',
    padding: '3px 8px',
    color: colors.navy,
    fontWeight: 500,
  },
  crumbSep: {
    display: 'inline-flex',
    color: '#CBD0D7',
  },
  video: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '16px',
    padding: '12px',
    border: `1px solid ${colors.border}`,
    borderRadius: '16px',
    background: '#FFFFFF',
    cursor: 'pointer',
    textAlign: 'left',
    fontFamily: 'inherit',
    '&:hover': {
      borderColor: colors.primaryLighter,
    },
  },
  thumb: {
    position: 'relative',
    width: 176,
    aspectRatio: '16 / 9',
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '10px',
    overflow: 'hidden',
    background: 'linear-gradient(135deg,#0B1B2B,#0A3D91)',
  },
  thumbLines: {
    position: 'absolute',
    top: 14,
    left: 14,
    right: 14,
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    '& > div': {
      height: 5,
      borderRadius: '3px',
    },
  },
  play: {
    position: 'relative',
    width: 40,
    height: 40,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    background: '#FFFFFF',
    color: colors.primary,
    boxShadow: '0 6px 16px rgba(0,0,0,.3)',
  },
  videoText: {
    flex: 1,
    minWidth: 200,
  },
  videoTitle: {
    fontSize: '15px',
    fontWeight: 600,
    color: colors.navy,
  },
  videoDesc: {
    marginTop: 3,
    fontSize: '13px',
    lineHeight: 1.5,
    color: colors.muted,
  },
  watch: {
    marginRight: 4,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '8px 14px',
    borderRadius: '8px',
    background: colors.primary,
    fontSize: '13px',
    fontWeight: 500,
    color: '#FFFFFF',
  },

  // Steps
  guide: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  steps: {
    padding: '8px 24px',
    border: `1px solid ${colors.border}`,
    borderRadius: '16px',
    background: '#FFFFFF',
  },
  step: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    padding: '18px 0',
    '& + &': {
      borderTop: '1px solid #F1F3F5',
    },
  },
  stepNumber: {
    width: 28,
    height: 28,
    flex: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    background: colors.primarySoft,
    fontSize: '13px',
    fontWeight: 600,
    color: colors.primary,
  },
  stepBody: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  stepTitle: {
    fontSize: '15px',
    fontWeight: 600,
    color: colors.navy,
  },
  stepDesc: {
    marginTop: 3,
    fontSize: '14px',
    lineHeight: 1.55,
    color: colors.muted,
  },
  url: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 6px 6px 12px',
    borderRadius: '8px',
    background: colors.hover,
  },
  urlText: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontFamily: 'ui-monospace, Menlo, monospace',
    fontSize: '13px',
    color: colors.navy,
  },
  copy: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '8px 14px',
    border: 0,
    borderRadius: '6px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
  },
  guideFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '12px',
    padding: '0 4px',
    fontSize: '13px',
    color: colors.subtle,
  },
  support: {
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    color: colors.primary,
  },

  // What you can do
  uses: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 340px), 1fr))',
    gap: '16px',
  },
  use: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    padding: '22px 24px',
    border: `1px solid ${colors.border}`,
    borderRadius: '16px',
    background: '#FFFFFF',
  },
  useHead: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
  },
  useIcon: {
    width: 36,
    height: 36,
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '10px',
    background: colors.primarySoft,
    color: colors.primary,
  },
  prompts: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  prompt: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    padding: '10px 12px',
    border: '1px solid transparent',
    borderRadius: '8px',
    background: colors.hover,
    cursor: 'pointer',
    textAlign: 'left',
    fontFamily: 'inherit',
    fontSize: '13px',
    lineHeight: 1.45,
    color: colors.navy,
    '&:hover': {
      background: colors.primarySoft,
      borderColor: 'rgba(1,95,251,.3)',
    },
  },
  promptIcon: {
    marginTop: 2,
    display: 'inline-flex',
    flex: 'none',
    color: colors.subtle,
  },
})

export default useStyles
